import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { SsoStatus } from '@pages/login/models/sso-status.interface';
import { hideServerNotRespondWarningWhenDegraded } from '@core/errors/models/context';

@Injectable({
  providedIn: 'root',
})
export class SsoStatusService {
  private readonly httpClient = inject(HttpClient);

  getSsoStatus(organizationName: string, trackingId: string): Observable<SsoStatus> {
    const url = 'api/v2/sso/status';

    return this.httpClient.post<SsoStatus>(
      environment.portalApiUrl + url,
      { organizationName, uuid: trackingId },
      { context: hideServerNotRespondWarningWhenDegraded() }
    );
  }
}
